module.exports = __webpack_public_path__ + "media/svg-new/avatar-20 1-35694188.svg";